import { Component } from '@angular/core';
import { BasePage } from '../BasePage';

@Component({
  selector: 'app-reporting',
  templateUrl: './reporting.component.html',
  standalone: false,
})
export class ReportingComponent extends BasePage {}
